module.exports = __webpack_public_path__ + "img/2bcb3ee.svg";